import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import MainLayout from './MainLayout';

const Authentication = () => {
    const accessToken = useSelector((state) => state.auth.accessToken);
    return accessToken ? <MainLayout /> : <Navigate to={'login'} replace />;
};

export default Authentication;


// import { useSelector } from "react-redux";
// import { Navigate, useLocation } from "react-router-dom";
// import MainLayout from "./MainLayout";
// import { useDispatch } from "react-redux";
// import { clearToken } from "../redux/authSlice";

// import {
//     removeGarmentRemarks,
//     removeLocalAppServices,
//     removeLocalPackageBooking,
//     removeLocalServiceUnit,
//     removeLocalPriceCode,
//     removeSelectedDocsSchedule,
//     removeUserData,
//     removeLocalGarmentRemarksPriority,
//     removeLocalChargesAndDiscount,
//     removeLocalStorePaymentGatewayConfig,
//     removeLocalPaymentMode,
//     removeLocalStoreDefaultPrice,
//     removeLocalFranchiseRate,
//     removeLocalFranchiseStore,
//     removeLocalFranchiseUserInfo,
//     removeLocalFranchiseInfo,
//     removeLocalAdminSelectedStore,
//     removeLocalGarmentPack,
//     removeStoreLocalData,
// } from "../utils/localStorage";


// const Authentication = () => {
//     const accessToken = useSelector((state) => state.auth.accessToken);
//     const dispatch = useDispatch();
//     const location = useLocation();

//     const hostProfile = localStorage.getItem("hostProfile");


//     const logoutUser = () => {
//         removeUserData();
//         removeSelectedDocsSchedule();
//         removeGarmentRemarks();
//         removeLocalServiceUnit();
//         removeLocalAppServices();
//         removeLocalStoreDefaultPrice();
//         removeLocalPaymentMode();
//         removeLocalStorePaymentGatewayConfig();
//         removeLocalChargesAndDiscount();
//         removeLocalGarmentPack();
//         removeLocalFranchiseUserInfo();
//         removeLocalFranchiseStore();
//         removeLocalFranchiseRate();
//         removeLocalFranchiseInfo();
//         removeLocalPriceCode();
//         removeLocalAdminSelectedStore();
//         removeLocalPackageBooking();
//         removeLocalGarmentRemarksPriority();
//         removeStoreLocalData();

//         dispatch(clearToken());
//     };


//     if (!accessToken || !hostProfile) {
//         logoutUser();

//         return <Navigate to="/login" replace state={{ from: location }} />;
//     }


//     return <MainLayout />;
// };


// export default Authentication;